// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3wM8T","inner":"Footer_inner__2RYq8","nextIcon":"Footer_nextIcon__3ghz5","innerLeft":"Footer_innerLeft__2kyBt"};